export const COMPONENT_NAME = 'VideoDetails';
